const getImageAlt = (file) => {
    const baseName = file.name.replace(/\.[^.]+$/, "") || "image";
    return baseName.replace(/[\\[\]]/g, "\\$&");
};
export const createUploadPlaceholder = (file) => {
    const token = `nf-vault-upload-${crypto.randomUUID()}`;
    return `[Uploading ${getImageAlt(file)}...](${token})`;
};
export const createImageMarkdown = (file, url) => {
    return `![${getImageAlt(file)}](${url})`;
};
export const createUploadErrorMarkdown = (file) => {
    return `![Image upload failed: ${getImageAlt(file)}]()`;
};
